// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__yBGvI","detailsBorder":"styles_detailsBorder__DrayB"};